"use strict";

var _taggedTemplateLiteral = require("/home/circleci/project/story/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.Name = exports.Link = exports.Content = exports.Container = exports.Category = exports.Bold = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _typography = require("@titelmedia/bricks-theme/lib/utilities/typography");

var _layout = require("@titelmedia/bricks-theme/lib/utilities/layout");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Content = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: 2px;\n  display: flex;\n"])));

exports.Content = Content;

var Container = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n\n  @media (min-width: 992px) {\n    columns: 2;\n  }\n\n  h3:first-child {\n    margin-top: 0;\n  }\n"])), (0, _layout.setContainer)({
  size: 'md'
}));

exports.Container = Container;

var Category = _styledComponents.default.h3(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-weight: normal;\n  ", "\n  ", "\n  text-transform: uppercase;\n  margin: 16px 0;\n"])), (0, _typography.setFont)({
  bold: true
}), (0, _typography.setFontSizes)({
  mobile: '11px',
  tablet_vertical: '13px'
}));

exports.Category = Category;

var Title = _styledComponents.default.p(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin: 0px 6px 0px 0px;\n  ", "\n  ", "\n  line-height: 140%;\n"])), (0, _typography.setFont)({
  bold: true
}), (0, _typography.setFontSizes)({
  mobile: '11px',
  tablet_vertical: '13px'
}));

exports.Title = Title;

var Name = _styledComponents.default.p(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin: 0px;\n  color: inherit;\n  ", "\n  ", "\n  line-height: 140%;\n"])), (0, _typography.setFont)({}), (0, _typography.setFontSizes)({
  mobile: '11px',
  tablet_vertical: '13px'
}));

exports.Name = Name;

var Link = _styledComponents.default.a(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  color: inherit;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n"])));

exports.Link = Link;

var Bold = _styledComponents.default.strong(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-family: 'univers-bold';\n"])));

exports.Bold = Bold;